'use strict';

(function ($, Drupal, drupalSettings, undefined) {

  Drupal.behaviors.mann_theme_views = {
    attach: function attach(context, settings) {

      if (!$('.views-exposed-form', context).hasClass("initialised")) {
        $('.views-exposed-form', context).addClass("initialised");

        $('.views-exposed-form', context).on("click touchstart", "legend", function (e) {
          e.preventDefault();

          if ($(this).parents('.fieldgroup').hasClass("open")) {
            $(this).parents('.fieldgroup').removeClass("open");
            $(this).parents('.fieldgroup').addClass("closed");
          } else {
            $(this).parents('.fieldgroup').removeClass("closed");
            $(this).parents('.fieldgroup').addClass("open");
          }
        });
      }
    }
  };
})(jQuery, Drupal, drupalSettings);